import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MotdEditDialogComponent } from '../motd-edit-dialog/motd-edit-dialog.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import { PrimaryButtonComponent } from '../../shared/buttons/primary-button.component';

@Component({
  selector: 'sibat-motd-widget',
  template: `
    <sibat-widget *transloco="let t; read: 'cockpit'" [title]="t('welcomeMessage')">
      <mat-icon widget-icon>announcement</mat-icon>
      <div widget-content class="content">
        <sibat-primary-button
          [label]="t('edit')"
          [submit]="false"
          [disabled]="false"
          [stretch]="true"
          (clicked)="editMotd()"
          class="start-button"
        ></sibat-primary-button>
      </div>
    </sibat-widget>
  `,
  styleUrls: ['motd-widget.component.scss'],
  imports: [TranslocoDirective, WidgetComponent, MatIcon, PrimaryButtonComponent],
})
export class MotdWidgetComponent {
  constructor(private dialog: MatDialog) {}

  editMotd() {
    this.dialog.open(MotdEditDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      height: '80vh',
      panelClass: 'motd-dialog',
    });
  }
}
